<template>
    <div id="fullscreen-image-viewer">
        <!-- FILE -->
        <div class="image-container">
            <ci-image-viewer v-if="imageUrl" ref="img-viewer" :url="imageUrl" />
        </div>

        <!-- ACTIONS -->
        <div class="actions">
            <!-- Custom actions -->
            <slot></slot>

            <a :href="imageUrl" class="action-btn mr-2" download target="_blank">
                <icon name="download" scale=".75" />
            </a>

            <div @click="rotate" class="action-btn mr-2">
                <icon name="undo" scale=".75" flip="horizontal" />
            </div>

            <div @click="hide" class="action-btn mr-2">
                <icon name="compress" scale=".75" flip="horizontal" />
            </div>

            <div class="zoom-btn-container">
                <div @click="zoomIn" class="zoom-btn">
                    <icon name="plus" scale=".75" />
                </div>
                <div @click="zoomOut" class="zoom-btn">
                    <icon name="minus" scale=".75" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FullScreenImageViewer',

    data() {
        return {
            imageUrl: null,
        }
    },

    methods: {
        show(imageUrl) {
            this.imageUrl = imageUrl

            const container = document.getElementById('fullscreen-image-viewer')
            container.classList.add('active')

            // Add Escape press handler
            document.body.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.hide()
                }
            })
        },

        hide() {
            this.imageUrl = null

            const container = document.getElementById('fullscreen-image-viewer')
            container.classList.remove('active')
        },

        // Default actions
        zoomIn() {
            this.$refs['img-viewer'].zoomIn()
        },
        zoomOut() {
            this.$refs['img-viewer'].zoomOut()
        },
        rotate() {
            this.$refs['img-viewer'].rotate()
        },
    },
}
</script>
<style lang="scss" scoped>
#fullscreen-image-viewer {
    display: none;

    &.active {
        display: flex;
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: var(--primary-2);
        z-index: 100000000;
        left: 0;
        top: 0;
        padding: 16px;
        align-items: center;

        .actions {
            display: flex;
            flex-direction: column;
            margin-left: 12px;
            .action-btn,
            .zoom-btn {
                width: 32px;
                height: 32px;
                background-color: var(--primary-3);
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 8px;
                cursor: pointer;
                &:hover {
                    opacity: 0.8;
                }

                svg {
                    color: var(--light);
                }
            }

            .zoom-btn-container {
                .zoom-btn {
                    margin-bottom: 0;
                    &:first-child {
                        border-radius: 4px 4px 0 0;
                    }

                    &:last-child {
                        border-radius: 0 0 4px 4px;
                        border-top: 1px solid var(--primary-2);
                    }
                }
            }
        }

        .image-container {
            width: calc(100% - 80px);
            height: 100%;
            background-color: var(--light);
        }
    }
}
</style>
